import dayjs from 'dayjs'

import Tag from '@atoms/Tag'
import Icon from '@components/utils/Icon'
import { whenLabel } from '@utils/callbackTime'

import { OUTCOME_LABELS, type Outcome } from './LogContactForm'
import { CallbackCard, type CallbackDraft } from './ScheduleCallbackFields'

/**
 * Today's ContactsLog and ContactLogCard (show-supporter), with sample data and
 * one addition: a call that booked a callback shows that callback under its note.
 */

export type ContactEntry = {
  id: string
  outcome: Outcome
  at: string
  by: string
  note: string
  callback?: CallbackDraft
}

const ERROR_OUTCOMES: Outcome[] = ['inaccessible', 'not_interested']

export function ContactsLog({
  contacts,
  ownerName,
  meId,
  now,
}: {
  contacts: ContactEntry[]
  ownerName: (callback: CallbackDraft) => string
  meId: string
  now: Date
}) {
  return (
    <div className="tw:rounded-xl tw:border tw:border-gray-200 tw:bg-white tw:shadow-xs tw:[&>*:last-child]:border-b-0 tw:*:border-b tw:*:border-gray-200">
      {contacts.map((c) => (
        <div key={c.id} className="tw:flex tw:gap-8 tw:px-8 tw:py-5 tw:text-sm tw:text-gray-700">
          <div className="tw:flex tw:flex-col">
            <div className="tw:flex tw:h-10 tw:w-10 tw:items-center tw:justify-center tw:rounded-full tw:border tw:border-gray-200 tw:bg-white tw:text-primary-700 tw:shadow-xs">
              <Icon type="phone-call-01" width={20} height={20} />
            </div>
            <p className="tw:text-base tw:whitespace-nowrap tw:py-2 tw:font-semibold">{dayjs(c.at).format('D MMM')}</p>
          </div>
          <div className="tw:flex tw:w-full tw:min-w-0 tw:flex-col tw:gap-3">
            <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-2">
              <Tag color={ERROR_OUTCOMES.includes(c.outcome) ? 'error' : 'success'} size="sm">
                {OUTCOME_LABELS[c.outcome]}
              </Tag>
              <span className="tw:text-xs">{whenLabel(c.at, now)}</span>
            </div>
            <p>
              <span className="tw:font-semibold">Phone call: </span>
              {c.by}
            </p>
            {c.note && <p>{c.note}</p>}
            {c.callback && (
              <CallbackCard callback={c.callback} ownerName={ownerName(c.callback)} meId={meId} now={now} />
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
